import {Component, OnDestroy, OnInit} from '@angular/core';
import {InvalidateSubject} from "@shared/helpers/invalidate.subject";
import {IDialogView} from "@shared/components/ok-cancel-dialog/ok-cancel-dialog.component";
import {DialogModel} from "@shared/models/dialog.model";
import {Configuration} from "@shared/models/configuration";
import {CommandService} from "@core/services/command.service";
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {ParticleState} from "@shared/store/reducers/particle.reduer";
import {Store} from "@ngrx/store";
import {SnackBarService} from "@core/services/snack-bar.service";
import {DialogService} from "@shared/services/dialog-service";
import {DeleteArrangementChartCommand, UpdateArrangementChartCommand} from '../../commands/dac6-reporter.command';
import {ArrangementChart} from "../../Fields";
import {takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";

@Component({
    standalone: false,
    selector: 'particle-arrangement-chart-grid-view-dialog',
  templateUrl: './arrangement-chart-grid-view-dialog.component.html',
  styleUrls: ['./arrangement-chart-grid-view-dialog.component.scss']
})
export class ArrangementChartGridViewDialogComponent implements OnInit, IDialogView, OnDestroy {
  data: DialogModel;
  invalidateSubject: InvalidateSubject;
  private unSubscribe = new Subject<void>();
  sourceType: string;
  childrenFilterEnabled = false;
  constructor(private dialogService: DialogService,
              private snackberService: SnackBarService,
              protected particleStore: Store<ParticleState>,
              private fuseSplashScreenService: FuseSplashScreenService,
              private commandService: CommandService) {
    this.invalidateSubject = new InvalidateSubject();
  }

  ngOnInit() {
    const config = Configuration.getSmartGridConfig(this.data.input['sourceType']);
    if(config){
      config.Parameters['PARENT_ID'] = this.data.input['parentId'];
      config.Parameters['FORM_ID'] = this.data.input['formId'];
      this.sourceType = config.SourceType;
    }else{
      console.log(`Config not found for ${this.data.input['sourceType']}`)
    }
  }
  onGridCellValueChange(event) {

    if (event.action) {
      switch (event.action.id) {
        case 'Delete':
          this.delete(event);
          break;
        case 'Edit':
          this.editRecord(event);
          break;
      }
    }
    console.log(event);
  }
  private editRecord(event: any) {
    this.openEditor(event);
  }
  public openEditor(event: any) {
    let minWidth = '800px';
    const maxWidth = '800px';
    this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, minWidth, maxWidth, this.data.input['sourceType']).subscribe(state => {
      console.log('After Edit', state);
      if (state.action === 'OK') {
        let itemValue = {};
        if(event.fieldDefinition.key === ArrangementChart.Person ||
          event.fieldDefinition.key === ArrangementChart.Address ||
          event.fieldDefinition.key === ArrangementChart.Organisation){
          itemValue = this.getFlatFormattedItemValue(event);
        }else{
          itemValue[`${event.fieldDefinition.key}`] = event.item.cells[event.fieldDefinition.key].value;
        }
        if(Object.keys(itemValue).length > 0){
          const command = new UpdateArrangementChartCommand(event.item.id, itemValue);
          this.commandService.executeCommand(command).subscribe(commandState=>{
            console.log('Success');
            this.invalidateSubject.invalidate();
          })
        }
      }
    });
  }
  onOkClicked(): boolean {
    return true;
  }

  private delete(event: any) {
    const dialogRef = this.dialogService.showConfirmDialog('Delete Record', 'Done', 'Cancel', 'If you delete this record then the child records will also be deleted.', 'Are you sure to delete the record?');
    dialogRef.pipe(takeUntil(this.unSubscribe)).subscribe((response: any)=>{
      if(response && response.action == 'OK'){
        this.deleteRecord(event);
      }
    })
  }

  private getFlatFormattedItemValue(event: any) {
    const fieldValues = {};
    if(event.item.cells[event.fieldDefinition.key] &&
      event.item.cells[event.fieldDefinition.key].value &&
      event.item.cells[event.fieldDefinition.key].value.fieldValues){
      Object.keys(event.item.cells[event.fieldDefinition.key].value.fieldValues).forEach(key=>{
        fieldValues[key]=event.item.cells[event.fieldDefinition.key].value.fieldValues[key];
      })
    }
    return fieldValues;
  }
  ngOnDestroy(): void {
    this.unSubscribe.next();
    this.unSubscribe.complete();
  }

  private deleteRecord(event: any) {
    console.log('Delete Item');
    const command = new DeleteArrangementChartCommand(event.item.id);
    this.commandService.executeCommand(command).subscribe(response=>{
      this.snackberService.showInformation('Entity deleted');
      this.invalidateSubject.invalidate();
    })
  }
  Add(){

  }
  AddRecord(){
    const dialogModel: DialogModel = DialogModel.create(
      'Add New Record',
      'AddArrangmentChartRecordDialogComponent', {},
      '800px',
      '800px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      if (res.action === 'OK') {
        console.log('after hashtag dialog, Expecitng caseId:', res);
        this.commandService.executeCommand(dialogModel.input['addRecordCommand']).subscribe(response=>{
          this.snackberService.showInformation('Record added successfully');
          this.invalidateSubject.invalidate();
        })
      }
    });
  }
  openFilter(){
    const dialogModel: DialogModel = DialogModel.create(
      'Filter data',
      'ArrangmentChartFilterDialogComponent', {},
      '800px',
      '800px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      if (res.action === 'OK') {
        console.log('after hashtag dialog, Expecitng caseId:', res);
      }
    });
  }
  showEntityChildrensDialog(){
    const dialogModel: DialogModel = DialogModel.create(
      'Select Entity',
      'ArrangementChartChildrenDropDownDialogComponent',
      {},
      '500px',
      '500px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      if (res.action === 'OK') {
        const config = Configuration.getSmartGridConfig(this.data.input['sourceType']);
        this.childrenFilterEnabled = true;
        config.Parameters['PARENT_ID'] = res.data.input['selectedEntity'];
        config.Parameters['FORM_ID'] = '';
        this.invalidateSubject.invalidate();
      }
    });
  }
  clearChildrenFilter(){
    const config = Configuration.getSmartGridConfig(this.data.input['sourceType']);
    this.childrenFilterEnabled = false;
    config.Parameters['PARENT_ID'] = this.data.input['parentId'];
    config.Parameters['FORM_ID'] = this.data.input['formId'];
    this.invalidateSubject.invalidate();
  }
}
